
export default {
  data() {
    return {
      isMobile: false,
      showPhoneNumber: false,
      showEmail: false,
      showPhoneNumberContactNow: false,
      showEmailContactNow: false,
      styleProps: {
        windowHeight: "",
        windowWidth: "",
        pageOffset: 0,
        articleOffset: 600,
      },


      language: {
        // selected: { value: 'hu', title: this.$i18n.t('tooltip.language.hu'), flag: require('@/assets/flag-hu.png') },
        items: [
          { value: 'hu', title: this.$i18n.t('tooltip.language.hu'), flag: require('@/assets/flag-hu.png') },
          { value: 'en', title: this.$i18n.t('tooltip.language.en'), flag: require('@/assets/flag-en.png') },
          // translations needed
          // { value: 'de', title: this.$i18n.t('tooltip.language.de'), flag: require('@/assets/flag-de.png') },
        ],
      },
    };
  },

  created() {
    this.styleProps.windowHeight = window.innerHeight;
    this.styleProps.windowWidth = window.innerWidth;
    this.detectMobile();
  },

  mounted() {
    window.addEventListener('resize', () => {
      this.styleProps.windowHeight = window.innerHeight;
      this.styleProps.windowWidth = window.innerWidth;
    });
  },

  computed: {
    computedHeight() {
      return this.styleProps.windowHeight;
    },
    computedPageHeight() {
      return this.styleProps.windowHeight - this.styleProps.pageOffset;
    },
    computedArticleHeight() {
      return this.styleProps.windowHeight - this.styleProps.articleOffset;
    },

    computedWidth() {
      return this.styleProps.windowWidth;
    },

    selectedLanguageDetails() {
      return this.language.items.find(el => el.value == this.$i18n.locale);
    }


  },

  methods: {
    // ??
    detectMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    loadPage(name) {
      if(!!name) {
        this.$router.push({name: name }, () => {});
        window.scrollTo(0, 0);
      }
    },

    changeLanguage(selectedLanguage) {
      this.$i18n.locale = selectedLanguage.value
      this.$route.params.locale = selectedLanguage.value;
      // this.loadPage(this.$route.name)
    },
    setLangDe(isDe) {
      this.$store.commit("setLangDe", isDe);
    },

    toggleShowPhoneNumber() {
      this.showPhoneNumber = !this.showPhoneNumber
    },
    toggleShowEmail() {
      this.showEmail = !this.showEmail
    },

    toggleShowPhoneNumberContactNow() {
      this.showPhoneNumberContactNow = !this.showPhoneNumberContactNow
    },
    toggleShowEmailContactNow() {
      this.showEmailContactNow = !this.showEmailContactNow
    },
  },

  watch: {
    'selectedLanguageDetails'() {
      this.$i18n.locale = this.selectedLanguageDetails.value;
    },

    '$i18n.locale'(next, prev) {
      this.language.selected = this.language.items.find(el => el.value == this.$i18n.locale);
    }
  }
};
